// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"117":"79325677","396":"b60788d4","755":"b70ddb26","906":"979528c5","961":"497972ee"}[chunkId] + ".css";
};